$(document).ready(function(){
  // $('.dropdown-menu').each(function(){
  //   if($(this).find('.mega_menu_img_div') == true){
  //     $(this).parents('.nav-item').addClass('mega_dropdown');
  //   }
  // });

  $('.mega_menu_img_div').each(function(){
    
      $(this).parents('li').addClass('mega_dropdown');
   
  });
  // $(".select_button").removeClass();
  // $(".main_add_cart_button").click(function(){
  //   $(this).css("background-color","#7B9DF7");
  // })
  
});

$(function(){
  // $(".account_menu").hide();
  
})